import classnames from 'classnames';
import React from 'react';
import { useId } from "react-id-generator";


interface CheckboxProps {
    /** Indicates whether or not the Checkbox should be checked. */
    checked?: boolean,
    /** CSS class name. This will apply on the top level container element of the component. */
    className?: string,
    /** Whether or not the checkbox should be disabled. */
    disabled?: boolean,
    /** ID prefix for the IDs that will be assigned to various elements. Also used for the testIDs. If null, an ID will be generated. */
    idPrefix?: string,
    /** Optional label of the checkbox. */
    label?: string,
    /** Value of the name property of the checkbox for use on forms. */
    name?: string,
    /** onChange handler of the checkbox. Fired when checked state changes. */
    onChange?: any,
    /** OnClick handler of the checkbox. Fired when the checkbox is clicked. */
    onClick?: any,
    /** Flag that indicates the checkbox cannot be modified. */
    readOnly?: boolean,
    /** Value of the checkbox field. */
    value?: string
}

/**
 * Generic checkbox component that displays an attractive checkmark in place of the 
 * default HTML checkbox. Well suited when needing to display standalone checkboxes.
 * 
 * @param {object} props 
 */
function Checkbox(props: CheckboxProps) {

    const idPrefix = props.idPrefix || useId(1, "checkbox")[0];

    return (
        <label className={classnames("checkbox-container", props.className, { 'disabled': props.disabled })} data-testid={idPrefix + "Container"} htmlFor={idPrefix + "Input"}>
            <input
                checked={props.checked}
                className="checkbox-input"
                disabled={props.disabled}
                data-testid={idPrefix + "Input"}
                id={idPrefix + "Input"}
                name={props.name}
                onChange={props.onChange}
                onClick={props.onClick}
                readOnly={props.readOnly}
                type="checkbox"
                value={props.value} />
            <span className="checkbox"></span>
            {props.label && <span className="checkbox-label">{props.label}</span>}
        </label>
    );

}

export default Checkbox;